if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.injectSuccessStyles();
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;

              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            }

            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');

            if (this.cart) {
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      CartPerformance.measure('add:paint-updated-sections', () => {
                        this.cart.renderContents(response);
                      });
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                CartPerformance.measure('add:paint-updated-sections', () => {
                  this.cart.renderContents(response);
                });
              }
            }

            /*
             * O retorno de /cart/add.js não contém o total consolidado do carrinho.
             * Por isso consultamos /cart.js imediatamente e atualizamos o contador
             * personalizado do Header Inteligente.
             */
            if (window.AlcimoCartSync) {
              await window.AlcimoCartSync.refresh();
            }

            this.showAddedConfirmation();
          })
          .catch((error) => {
            console.error(error);
            this.handleErrorMessage('Não foi possível adicionar o produto. Tente novamente.');
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');

            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }

            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            if (spinner) spinner.classList.add('hidden');

            CartPerformance.measureFromEvent('add:user-action', evt);
          });
      }

      showAddedConfirmation() {
        const existing = document.querySelector('[data-alcimo-cart-toast]');
        if (existing) existing.remove();

        const toast = document.createElement('div');
        toast.setAttribute('data-alcimo-cart-toast', '');
        toast.setAttribute('role', 'status');
        toast.setAttribute('aria-live', 'polite');

        toast.innerHTML = `
          <span class="alcimo-cart-toast__check" aria-hidden="true">✓</span>
          <div class="alcimo-cart-toast__content">
            <strong>Produto adicionado ao carrinho</strong>
            <span>Você pode continuar comprando.</span>
          </div>
          <a class="alcimo-cart-toast__link" href="${window.routes.cart_url}">
            Ver carrinho
          </a>
        `;

        document.body.appendChild(toast);
        requestAnimationFrame(() => toast.classList.add('is-visible'));

        window.setTimeout(() => {
          toast.classList.remove('is-visible');
          window.setTimeout(() => toast.remove(), 350);
        }, 4500);
      }

      injectSuccessStyles() {
        if (document.getElementById('alcimo-cart-toast-styles')) return;

        const style = document.createElement('style');
        style.id = 'alcimo-cart-toast-styles';
        style.textContent = `
          [data-alcimo-cart-toast] {
            position: fixed;
            right: 24px;
            bottom: 24px;
            z-index: 99999;
            display: grid;
            grid-template-columns: auto 1fr auto;
            align-items: center;
            gap: 14px;
            width: min(460px, calc(100vw - 32px));
            padding: 18px 20px;
            background: #151513;
            color: #fff;
            border: 1px solid rgba(255,255,255,.14);
            box-shadow: 0 18px 50px rgba(0,0,0,.22);
            opacity: 0;
            transform: translateY(16px);
            pointer-events: none;
            transition: opacity .28s ease, transform .28s ease;
          }

          [data-alcimo-cart-toast].is-visible {
            opacity: 1;
            transform: translateY(0);
            pointer-events: auto;
          }

          .alcimo-cart-toast__check {
            display: grid;
            place-items: center;
            width: 30px;
            height: 30px;
            border: 1px solid rgba(255,255,255,.45);
            border-radius: 50%;
            font-size: 14px;
          }

          .alcimo-cart-toast__content {
            display: grid;
            gap: 3px;
          }

          .alcimo-cart-toast__content strong {
            color: #fff;
            font-size: 13px;
            line-height: 1.3;
            letter-spacing: .04em;
          }

          .alcimo-cart-toast__content span {
            color: rgba(255,255,255,.72);
            font-size: 12px;
            line-height: 1.4;
          }

          .alcimo-cart-toast__link {
            color: #fff;
            font-size: 11px;
            font-weight: 700;
            letter-spacing: .12em;
            text-transform: uppercase;
            text-decoration: none;
            border-bottom: 1px solid rgba(255,255,255,.5);
            padding-bottom: 2px;
            white-space: nowrap;
          }

          @media screen and (max-width: 749px) {
            [data-alcimo-cart-toast] {
              left: 16px;
              right: 16px;
              bottom: 16px;
              width: auto;
              grid-template-columns: auto 1fr;
            }

            .alcimo-cart-toast__link {
              grid-column: 2;
              justify-self: start;
              margin-top: 4px;
            }
          }
        `;

        document.head.appendChild(style);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) this.errorMessage.textContent = errorMessage;
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
